import React from 'react';
import { Monitor, TrendingUp, Users, Package } from 'lucide-react';
import { dashboardShowcase } from '../data/mock';

const iconMap = {
  0: TrendingUp,
  1: Users,
  2: Package
};

const DashboardShowcase = () => {
  return (
    <section className="py-24 lg:py-32 bg-[#232323]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-16">
          <span className="label-text text-[rgba(255,255,255,0.5)] mb-4 block">Data Visualization</span>
          <h2 className="section-title text-white">Dashboard Portfolio</h2>
          <p className="font-body text-lg text-[rgba(255,255,255,0.6)] mt-4 max-w-2xl">
            Interactive dashboards I've built to transform raw data into actionable business insights.
          </p>
        </div>

        {/* Dashboard Cards */}
        <div className="grid lg:grid-cols-3 gap-6">
          {dashboardShowcase.map((dashboard, idx) => {
            const Icon = iconMap[idx] || Monitor;
            const previewSrc =
              idx === 0
                ? '/vendor-dashboard.png'
                : idx === 1
                ? '/customer-dashboard.png'
                : null;

            return (
              <div
                key={dashboard.id}
                className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] p-6 group hover:border-[#38FF62] transition-all duration-300"
              >
                {/* Dashboard Preview */}
                <div className="aspect-video bg-[rgba(255,255,255,0.03)] mb-6 relative overflow-hidden rounded">
                  {previewSrc ? (
                    <img
                      src={previewSrc}
                      alt={dashboard.title}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <>
                      {/* Fallback mock preview */}
                      <div className="absolute inset-0 grid grid-cols-4 grid-rows-3 gap-2 p-3">
                        <div className="bg-[#38FF62]/20 col-span-2 row-span-1"></div>
                        <div className="bg-[rgba(255,255,255,0.1)] col-span-1 row-span-2"></div>
                        <div className="bg-[rgba(255,255,255,0.1)] col-span-1 row-span-1"></div>
                        <div className="bg-[rgba(255,255,255,0.05)] col-span-2 row-span-2"></div>
                        <div className="bg-[#38FF62]/10 col-span-1 row-span-1"></div>
                      </div>
                      <div className="absolute inset-0 flex items-center justify-center">
                        <Icon className="w-12 h-12 text-[#38FF62] opacity-50 group-hover:opacity-100 transition-opacity" />
                      </div>
                    </>
                  )}
                </div>

                {/* Title */}
                <h3 className="font-display text-lg font-semibold text-white mb-2">
                  {dashboard.title}
                </h3>
                
                {/* Description */}
                <p className="font-body text-sm text-[rgba(255,255,255,0.6)] mb-4">
                  {dashboard.description}
                </p>

                {/* Key Metrics */}
                <div className="space-y-2 mb-4">
                  {dashboard.metrics.map((metric, mIdx) => (
                    <div key={mIdx} className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 bg-[#38FF62]"></span>
                      <span className="font-mono text-xs text-[rgba(255,255,255,0.8)]">
                        {metric}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Tools Used */}
                <div className="flex flex-wrap gap-2 pt-4 border-t border-[rgba(255,255,255,0.1)]">
                  {dashboard.tools.map((tool, tIdx) => (
                    <span
                      key={tIdx}
                      className="px-2 py-1 bg-[rgba(255,255,255,0.1)] font-mono text-[10px] uppercase tracking-wider text-[rgba(255,255,255,0.6)]"
                    >
                      {tool}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default DashboardShowcase;